import * as Yup from 'yup';

import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
} from 'react-bootstrap';
import { Field, Formik } from 'formik';
import React, { useState } from 'react';

import { Auth } from 'aws-amplify';
import CloseButton from '../Styled/CloseButton';
import ErrorLabel from '../../ui/ErrorLabel';
import currentUserPropTypes from '../../propTypes/currentUserPropTypes';
import cx from 'classnames';
import modalPropTypes from '../../propTypes/modalPropTypes';

const EditNameModal = ({ show, onHide, currentUser, setUser }) => {
  const schema = Yup.object().shape({
    givenName: Yup.string().min(1).max(256).required('First name is required'),
    familyName: Yup.string().min(1).max(256).required('Last name is required'),
  });

  // TODO: make this reusable
  const [showAlert, setShowAlert] = useState(false);
  const [alert, setAlert] = useState(undefined);

  const addAlert = (variant, message) => {
    setShowAlert(true);
    setAlert({ variant, message });
  };

  const hideAlert = () => {
    setShowAlert(false);
    setAlert(undefined);
  };

  const onSubmit = async values => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const attributes = {
        given_name: values.givenName,
        family_name: values.familyName,
      };
      await Auth.updateUserAttributes(user, attributes);
      addAlert('success', 'Your account has been updated.');
      setUser({
        ...currentUser,
        attributes: {
          ...currentUser.attributes,
          given_name: attributes.given_name,
          family_name: attributes.family_name,
        },
      });
      setTimeout(() => {
        onHide();
      }, 500);
    } catch (error) {
      addAlert('danger', error.message);
    }
  };

  return (
    <Modal
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={onHide}>
      <Modal.Header>
        <CloseButton onClick={onHide} variant={'bordered'} />
      </Modal.Header>
      <Modal.Body className="pt-0 pb-4">
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            givenName: currentUser?.attributes?.given_name,
            familyName: currentUser?.attributes?.family_name,
          }}
          validateOnChange>
          {({ handleSubmit, isValid, isSubmitting }) => (
            <Form onSubmit={handleSubmit}>
              <Container>
                <Row>
                  <Col md={10} className="mb-4">
                    <h2 className="color-dark">Please enter your new name</h2>
                  </Col>
                </Row>
                {showAlert && alert && (
                  <Row>
                    <Col className="mb-2">
                      <Alert
                        variant={alert.variant}
                        onClose={() => hideAlert()}>
                        {alert.message}
                        <CloseButton onClick={() => hideAlert()} />
                      </Alert>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col className="mb-2">
                    <Field name="givenName">
                      {({ field, meta }) => (
                        <Form.Group controlId="givenName">
                          <Form.Label>First name</Form.Label>
                          <Form.Control
                            type="text"
                            value={field.value}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                            isValid={!meta.error && meta.touched}
                            placeholder="First name"
                            className={cx({ error: !!meta.error })}
                          />
                          {meta.error && meta.touched && (
                            <ErrorLabel label={meta.error} />
                          )}
                        </Form.Group>
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row>
                  <Col className="mb-4">
                    <Field name="familyName">
                      {({ field, meta }) => (
                        <Form.Group controlId="familyName">
                          <Form.Label>Last name</Form.Label>
                          <Form.Control
                            value={field.value}
                            type="text"
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                            placeholder="Last name"
                            isValid={!meta.error && meta.touched}
                            className={cx({ error: !!meta.error })}
                          />
                          {meta.error && meta.touched && (
                            <ErrorLabel label={meta.error} />
                          )}
                        </Form.Group>
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <Button
                      className="w-100"
                      type="submit"
                      variant="primary"
                      disabled={!isValid && !isSubmitting}>
                      Save
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      className="w-100"
                      type="button"
                      variant="light"
                      onClick={onHide}>
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </Container>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

EditNameModal.propTypes = {
  ...currentUserPropTypes,
  ...modalPropTypes,
};

export default EditNameModal;
